<script setup lang="ts">
import { TypographyItem, TypographyWithPrefix } from '@/components/Typography'
import { computed, ref } from 'vue'
import type { EColors } from '../../types/constants/ColorValues'
import { IconButton } from '../Buttons'

type Props = {
    label?: string
    iconType?: EColors
}
const props = defineProps<Props>()

const isShowing = ref(false)
const icon = computed(() => (isShowing.value ? 'eye-slash' : 'eye'))
const currentLabel = computed(() => (isShowing.value ? props.label : '******'))

const handleIconClick = () => (isShowing.value = !isShowing.value)
</script>

<template>
    <TypographyWithPrefix class="showable-item" :style="{ 'flex-direction': 'row' }">
        <TypographyItem :label="currentLabel" />

        <template #edit>
            <IconButton
                :type="iconType"
                :icon="icon"
                class="clickable-icon"
                @click="handleIconClick" />
        </template>
    </TypographyWithPrefix>
</template>

<style scoped lang="scss">
.showable-item {
    & .text {
        align-content: center;
    }
}
.clickable-icon {
    cursor: pointer;
    color: $primary;
    border: unset;
}
</style>
